import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import ProgressButton from '../../../commons/ProgressButton';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import {
  App,
  Toolbar,
  ToolbarGroup,
  ToolbarItem,
  Editor,
  serializer,
} from '@organw/wysiwyg-editor';
import { defaultValue } from '../../../commons/EditorFunctions';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';
import ToolbarBase from '../../../components/Wysiwyg/toolbar/ToolbarBase';
import Wysiwyg from '../../../components/Wysiwyg/Wysiwyg';
import ToolbarPlaceholderRow from '../../../components/Wysiwyg/toolbar/ToolbarPlaceholderRow';

class Sablon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      szolgaltatasFilterSelected: null,
      szolgaltatasOptions: [],
      szolgaltatasokJSON: [],
      tipusFilterSelected: null,
      tipusOptions: [],
      dolgozok: [],
      sablonok: [],
      modalSablon: false,
      modalSablonView: false,
      modalSablonDelete: false,
      insert: false,
      dataLoaded: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: 'HIDD',
      // 'VISSZAIGAZOLAS', 'MODOSITAS', 'TORLES', 'REMINDER'
      maxSablonNumber: 4,
      hirlevelvariables: [],
      value: defaultValue(),
      valtozok: [],
      kategoriaOptions: [],
      saveButtonLoading: false,
      formTipus: '',
      currentId: undefined,
      targy: '',
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateSzolgaltatasFilter();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '4' && this.props.activeTab === '4') {
      this.updateSzolgaltatasFilter();
    }
  }

  convertSzolgaltatasJsonToOptions = () => {
    let mezok = [];
    let array = Array.from(this.state.szolgaltatasokJSON);
    array.sort((a, b) => { return a.nev.localeCompare(b.nev) });
    for (let szolgaltatas of array) {
      mezok.push(<option value={szolgaltatas.id}>{szolgaltatas.nev}</option>);
    }
    this.setState({ szolgaltatasOptions: mezok });
  }

  updateSzolgaltatasFilter = () => {
    Service.listDolgozo(false, (err, res) => {
      if (!err) {
        this.setState({ dolgozok: res[0] }, () => {
          let dolgozoidk = []
          for (let dolgozo of this.state.dolgozok) {
            dolgozoidk.push(dolgozo.id);
          }
          Service.listSzolgaltatasByDolgozok(null, dolgozoidk, (err, res) => {
            if (!err) {
              this.setState({ szolgaltatasokJSON: res[0] }, () => {
                this.convertSzolgaltatasJsonToOptions();
              });
            }
          });
        });
      }
    });
  }

  updateTipusFilter = () => {
    const sablonTipusok = ['VISSZAIGAZOLAS', 'MODOSITAS', 'TORLES', 'REMINDER'];
    const meglevoTipusok = [];
    const tipusOptions = [];
    for (let sablon of this.state.sablonok) {
      meglevoTipusok.push(sablon.tipus.name);
    }
    for (let tipus of sablonTipusok) {
      if (!meglevoTipusok.includes(tipus)) {
        let optionName = '';
        switch (tipus) {
          case 'VISSZAIGAZOLAS':
            optionName = "Visszaigazolás"
            break;
          case 'MODOSITAS':
            optionName = "Módosítás"
            break;
          case 'TORLES':
            optionName = "Törlés"
            break;
          case 'REMINDER':
            optionName = "Emlékeztető"
            break;
        }
        tipusOptions.push(<option value={tipus}>{optionName}</option>);
      }
    }
    this.setState({ tipusOptions });
  }

  iconFormatter = (cell) => {
    return (
      <div>
        {
          (
            <div>
              <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleSablonViewClick(cell)} />
              <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleSablonEditClick(cell)} />
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleSablonDeleteClick(cell)} />
            </div>
          )
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Előnézet</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'tipus.value',
        text: 'Típus',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'targy',
        text: 'Tárgy',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        })
      },
      {
        dataField: 'moduser',
        text: 'Utolsó módosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <div>
        <Button className="pull-left table-new-button" color="primary" hidden={this.state.sablonok.length == this.state.maxSablonNumber} onClick={this.handleSablonAddClick}>Új sablon</Button>
        <BootstrapTable2
          bootstrap4
          keyField="id"
          data={this.state.sablonok}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
        />
      </div>
    );
  }

  updateTable = (buttonPressed) => {
    const {
      szolgaltatasFilterSelected,
    } = this.state;
    if (!szolgaltatasFilterSelected) {
      if (buttonPressed != true)
        this.updateSzolgaltatasFilter();
      else
        this.props.globals.addError('Kereséshez szolgáltatás választása kötelező!');
    } else {
      this.setState({ tableStatus: 'LOAD' }, () => {
        Service.listSablon(szolgaltatasFilterSelected, (err, res) => {
          if (!err) {
            const status = res[0].length == 0 ? 'DATA' : 'TABL';
            this.setState({ sablonok: res[0], tableStatus: status });
            this.updateTipusFilter();
          } else {
            this.setState({ tableStatus: 'NETW' });
          }
        });
      });
    }
  }

  getVariables = () => {
    Service.initVariables((err, res) => {
      if (!err) {
        let valtozok = [];
        res[0].valtozo.forEach((item) => {
          let valtozo = {};
          valtozo.name = item.key;
          valtozo.caption = item.caption;
          valtozok.push(valtozo);
        })
        this.setState({ valtozok: valtozok });
      }
    });
  }

  toggleSablonView = () => {
    this.setState((prevState) => { return { modalSablonView: !prevState.modalSablonView } });
  }

  toggleSablon = () => {
    this.getVariables();
    this.setState((prevState) => { return { modalSablon: !prevState.modalSablon }; });
  }

  toggleSablonTorles = () => {
    this.setState((prevState) => { return { modalSablonDelete: !prevState.modalSablonDelete }; });
  }

  handleSzolgaltatasSelect = (event, value) => {
    this.setState({ szolgaltatasFilterSelected: value });
  }

  handleTipusSelect = (event, value) => {
    this.setState({ tipusFilterSelected: value });
  }

  handleSablonAddClick = () => {
    this.setState({
      insert: true,
      value: defaultValue(),
      currentId: undefined,
      formTipus: '',
      targy: '',
      tipusFilterSelected: null,
    }, () => {
      this.updateTipusFilter();
      this.getVariables();
      this.toggleSablon();
    });
  }

  handleSablonViewClick = (id) => {
    this.setState({ dataLoaded: false }, () => {
      Service.getSablon(id, (err, res) => {
        if (!err) {
          const adatok = res[0];
          this.setState({ dataLoaded: true, insert: false, currentId: id, targy: adatok.targy, tipusFilterSelected: adatok.tipus.value, value: adatok.tartalom });
        }
      });
      this.toggleSablonView();
    });
  }

  handleSablonEditClick = (id) => {
    this.setState({ dataLoaded: false }, () => {
      Service.getSablon(id, (err, res) => {
        if (!err) {
          const adatok = res[0];
          this.setState({ dataLoaded: true, insert: false, currentId: id, targy: adatok.targy, tipusFilterSelected: adatok.tipus.name, tipusOptions: <option value={adatok.tipus.name}>{adatok.tipus.value}</option>, value: adatok.tartalom });
        }
      });
      this.getVariables();
      this.toggleSablon();
    });
  }

  handleSablonDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleSablonTorles();
  }

  addSablon = () => {
    let submitObj = {};
    submitObj.tipus = this.state.tipusFilterSelected;
    submitObj.targy = this.state.targy;
    submitObj.tartalom = this.state.value;

    Service.addSablon(submitObj, this.state.szolgaltatasFilterSelected, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Sablon sikeresen felvéve!');
        this.toggleSablon();
        this.updateTable();
      }
    });
  }

  modifySablon = () => {
    let submitObj = {};
    submitObj.id = this.state.currentId;
    submitObj.tipus = this.state.tipusFilterSelected;
    submitObj.targy = this.state.targy;
    submitObj.tartalom = this.state.value;

    Service.editSablon(submitObj, this.state.szolgaltatasFilterSelected, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Sablon sikeresen módosítva!');
        this.toggleSablon();
        this.updateTable();
      }
    });
  }

  deleteSablon = () => {
    this.toggleSablonTorles();
    Service.deleteSablon(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Sablon törölve!');
      }
    });
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return (
          <div>
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleSablonAddClick}>Új sablon</Button>
            <DataEmptyState hasImage subtitle='Hozzon létre új sablont' />
          </div>
        );
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
      case 'HIDD':
        return <div />
    }
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  onChange = (value) => {
    this.setState({ value: value });
  };

  listImages = (callback) => {
    /*Services.listEditorImages((err,res) => {
      if(!err){
        callback(typeof res === "object" ? res[0] : []);
      }
    });*/
  }
  addImage = (file, callback) => {
    /*Services.uploadEditorImage(file, this.state.currentId, (err,res) => {
      if(!err){
        callback(file);
      }
    });*/
  }

  renderToolbarGroups = () => {
    const toolbarGroup = this.state.valtozok;
    return (
      <ToolbarGroup key={'HIRLEVEL'} style={{ border: '1px solid #cccccc' }}>
        {toolbarGroup.map((toolbaritem) => {
          return (
            <div key={toolbaritem.name}>
              <ToolbarItem
                onClick={(e) => { e.preventDefault(); }}
                type="text"
                name="text"
                tag={toolbaritem.name}
                style={{ width: 110 }}
              >
                <span
                  id={toolbaritem.name.substring(
                    2,
                    toolbaritem.name.length - 1
                  )}
                  style={{ width: '100%', height: '100%' }}
                >
                  {toolbaritem.caption}
                </span>
              </ToolbarItem>

              <UncontrolledTooltip trigger='hover focus-visible'
                placement="top"
                target={toolbaritem.name.substring(
                  2,
                  toolbaritem.name.length - 1
                )}
              >
                {toolbaritem.caption}
              </UncontrolledTooltip>
            </div>
          );
        })}
      </ToolbarGroup>
    );

  };

  renderTartalomForm = () => {
    const { value } = this.state;
    return (
      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-md-12">
          <Label>Tartalom: *</Label>
          <Wysiwyg
            key="sablon_form_wysiwyg"
            value={value}
            onChange={this.onChange}
            toolbar={() => 
              <>
                <ToolbarBase />
                <ToolbarPlaceholderRow
                  icon={<i className='fa fa-user' aria-hidden="true" />}
                  items={this.state.valtozok.map((x) => ({ code: x.name, caption: x.caption }))}
                />
              </>
            }
          />
        </div>
      </div>
    );
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  // replaceValues = () => {
  //   let viewValue = serializer.serialize(this.state.value);
  //   viewValue = viewValue.replaceAll("${NEV_TELJES}", 'Minta József');
  //   viewValue = viewValue.replaceAll("${DATUM}", "1999.01.01.");
  //   viewValue = viewValue.replaceAll("${SZOLGALTATAS}", "Szolgáltatás");
  //   viewValue = viewValue.replaceAll("${TEREMNEV}", "Teremnév");
  //   viewValue = viewValue.replaceAll("${KEZDET}", "1999.01.01. 12:00");
  //   viewValue = viewValue.replaceAll("${IDOTARTAM}", "10");
  //   viewValue = viewValue.replaceAll("${AR}", "5000");
  //   viewValue = viewValue.replaceAll("${MEGJEGYZES}", "Megjegyzés");
  //   viewValue = viewValue.replaceAll("${DOLGOZONEV}", "Dolgozó János");
  //   viewValue = viewValue.replaceAll("${DOLGOZOTEL}", "06309999999");
  //   viewValue = viewValue.replaceAll("${DOLGOZOEMAIL}", "minta@email.hu");
  //   viewValue = viewValue.replaceAll("${ELUTASITAS_OK}", "Elutasítás oka");
  //   return serializer.deserialize(viewValue);
  // }

  renderDataView = () => {
    const marginStyle = {
      marginBottom: 20,
    };
    // const viewValue = this.replaceValues();
    const viewValue = this.state.value;
    return this.state.dataLoaded ? (
      <div className="row">
        <div className="col-md-12">
          <div style={marginStyle}><b>Típus: </b>{this.state.tipusFilterSelected}<br /></div>
          <div style={marginStyle}><b>Tárgy: </b>{this.state.targy}<br /></div>
          <div><b>Tartalom:</b><br /></div>
          <Wysiwyg
            key={viewValue}
            value={viewValue}
            readOnly
            toolbar={null}
          />
        </div>
      </div>
    ) : this.renderLoader();
  }

  render() {
    const {
      targy,
    } = this.state;
    return (
      <div>
        <RFForm onSubmit={() => this.updateTable(true)}>
          <div className="row">
            <div className="col-md-3">
              <RFField
                type="select"
                name="szolgaltatasselect"
                value={this.state.szolgaltatasFilterSelected}
                onChange={this.handleSzolgaltatasSelect}
                defaultSelect={<option value='' disabled>Válassz szolgáltatást...</option>}
                selectOptions={this.state.szolgaltatasOptions}
              />
            </div>
            <div class="col-md-1">
              {/* <ProgressButton color="primary" type="submit" id="search" loading={false} onClick={() => this.updateTable(true)} >Lekérdezés</ProgressButton> */}
              <ProgressButton color="primary" type="submit" id="search" loading={false}>Lekérdezés</ProgressButton>
            </div>
          </div>
        </RFForm>
        {this.renderState()}
        <Modal isOpen={this.state.modalSablon} toggle={this.toggleSablon} className={this.props.className} backdrop="static" size="lg">
          <RFForm
            onSubmit={this.state.insert ? this.addSablon : this.modifySablon}
            modal
            title={"Sablon " + (this.state.insert ? "felvétel" : "módosítás")}
            footer={
              <>
                {/* <Button color="primary" onClick={this.state.insert ? this.addSablon : this.modifySablon}>{'Mentés'}</Button>{' '} */}
                <Button color="primary" type="submit">{'Mentés'}</Button>{' '}
                <Button color="secondary" onClick={this.toggleSablon}>Mégsem</Button>
              </>
            }
          >
            {this.state.dataLoaded || this.state.insert ?
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <RFField
                      label="Típus: *"
                      type="select"
                      name="tipusselect"
                      value={this.state.tipusFilterSelected}
                      onChange={this.handleTipusSelect}
                      required
                      disabled={this.state.insert ? false : true}
                      defaultSelect={<option value='' disabled>Válassz sablon típust...</option>}
                      selectOptions={this.state.tipusOptions}
                    />
                  </div>
                  <div className="col-md-6">
                    <RFField
                      label="Tárgy: *"
                      name="targy"
                      validate={value => value && value.length > 100 && "Maximum hossz: 100 karakter"}
                      value={targy}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {this.renderTartalomForm()}
                  </div>
                </div>
              </div>
              : this.renderLoader()
            }
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalSablonView} toggle={this.toggleSablonView} className={this.props.className} backdrop="static">
          <ModalHeader>Előnézet</ModalHeader>
          <ModalBody>{this.renderDataView()}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleSablonView}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalSablonDelete} toggle={this.toggleSablonTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a sablont?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteSablon}>OK</Button>
            <Button color="secondary" onClick={this.toggleSablonTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

}

export default Sablon;